<template>
  <v-card>
    <v-card-title class="headline background"> {{ title }}</v-card-title>

    <v-divider></v-divider>
    <v-layout column justify-center align-center>
      <v-card-text>
        <div class="px-2">
          <slot name="content"></slot>
        </div>
      </v-card-text>
    </v-layout>
    <v-divider></v-divider>
    <v-card-actions class="py-3">
      <slot name="left-actions">
        <v-btn text @click="cancel" data-cy="btn-cancel"
          >{{ i18n.t("_Cancel") }}
        </v-btn>
        <v-spacer />
      </slot>
      <slot name="actions"> </slot>
      <template v-for="(action, index) in actions">
        <v-btn
          :text="action.text"
          :color="action.color"
          :disabled="action.disabled"
          @click="
            action.method();
            dialog = false;
          "
          v-bind:key="index"
          :data-cy="action.name"
        >
          {{ action.buttonText }}
        </v-btn>
      </template>
    </v-card-actions>
  </v-card>
</template>
<script>
import i18n from "../helper/i18n"
export default {
  props: {
    title: {
      type: String,
      required: true,
    },
    width: {
      type: String,
      default: function () {
        return " auto";
      },
    },
    actions: {
      type: Array,
      default: function () {
        return [];
      },
    },
  },
  data() {
    return {
      dialog: false,
      i18n:i18n
    };
  },
  methods: {
    cancel() {
      this.dialog = false;
      this.$emit("cancel");
    },
  },
};
</script>

